import moment from 'moment'

// The application's server-time transport and local display formats.
//
// ApplicationHelper#local_date writes the server value in `serverTimeFormat`
// and the localize-server-time controller renders it locally. Save-status
// surfaces (for example the editor's save details) share these formats here so
// a saved time is shown exactly like every other local time in the app instead
// of growing a second formatting implementation.
export const serverTimeFormat = 'YYYY-MM-DD HH:mm:ss z'
export const calendarTimeFormats = {
  sameDay: '[Today] [at] LT',
  lastDay: '[Yesterday] [at] LT',
  nextDay: '[Tomorrow] [at] LT',
  lastWeek: 'MMM Do, YYYY [at] h:mm A',
  sameElse: 'MMM Do, YYYY [at] h:mm A',
}
export const displayTimeFormat = 'MMM Do, YYYY [at] h:mm A'

const helperTimePattern = /^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2} [A-Za-z]{2,5}$/
const isoTimePattern = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d{1,9})?(?:Z|[+-]\d{2}:?\d{2})$/

// Returns the local moment for a server value, or null when the value is
// missing or unparseable. Accepts the helper's `YYYY-MM-DD HH:mm:ss Z` string
// and the ISO 8601 timestamps the JSON save endpoints return. Each accepted
// transport is shape-checked before Moment parses it; this prevents a date-like
// typo from being interpreted in the browser's local timezone.
export function parseServerTime(value) {
  if (typeof value !== 'string' || !value) return null

  let parsed
  if (helperTimePattern.test(value)) {
    // ApplicationHelper emits UTC with `%Z`. The suffix is retained as part
    // of the recognized legacy shape; the old helper transport was UTC.
    parsed = moment.utc(value.slice(0, 19), 'YYYY-MM-DD HH:mm:ss', true)
  } else if (isoTimePattern.test(value)) {
    parsed = moment.parseZone(value, moment.ISO_8601, true)
  }
  return parsed?.isValid() ? parsed.local() : null
}

// Today/Yesterday/Tomorrow at h:mm A, otherwise a full local date.
export function formatCalendarTime(value) {
  const time = parseServerTime(value)
  return time ? time.calendar(null, calendarTimeFormats) : ''
}

export function formatDisplayTime(value, format = displayTimeFormat) {
  const time = parseServerTime(value)
  return time ? time.format(format) : ''
}
